<template>
    <div>
        
        <highlight-filter
            :getFilterOnStart="true"
            :is_customer_page="true"
            @filterChange="onFilterChange"
        ></highlight-filter>

        <!-- Stats Start -->
        <div class="row mt-4">
            <div class="col-md-6">
                <highlight-stats-customer
                    title="Total Scan Product"
                    :description="tooltip.total_scan_product"
                    :value="data.stats ? data.stats.scan : null"
                    icon="fa-barcode-read"
                    bg_color="rgba(73, 182, 213, 0.9)"
                ></highlight-stats-customer>
            </div>
            <div class="col-md-6">
                <highlight-stats-customer
                    title="Total Report Customer"
                    :description="tooltip.total_report_customer"
                    :value="data.stats ? data.stats.report : null"
                    icon="fa-engine-warning"
                    bg_color="rgba(253, 92, 87, 0.9)"
                ></highlight-stats-customer>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-4">
                <highlight-stats-customer
                    title="Valid Product"
                    :description="tooltip.valid_product"
                    :value="data.stats ? data.stats.valid : null"
                    icon="fa-badge-check"
                    bg_color="rgba(195, 223, 177)"
                ></highlight-stats-customer>
            </div>
            <div class="col-md-4">
                <highlight-stats-customer
                    title="Inactive Product"
                    :description="tooltip.inactive_product"
                    :value="data.stats ? data.stats.invalid : null"
                    icon="fa-times-hexagon"
                    bg_color="rgba(255, 205, 209)"
                ></highlight-stats-customer>
            </div>
            <div class="col-md-4">
                <highlight-stats-customer
                    title="Expired Product"
                    :description="tooltip.expired_product"
                    :value="data.stats ? data.stats.expired : null"
                    icon="fa-exclamation-triangle"
                    bg_color="rgba(205, 177, 223)"
                ></highlight-stats-customer>
            </div>
        </div>
        <!-- Stats End -->

        <!-- Reasons for Report Start -->
        <div class="innerBox mt-4">
            <h5 class="elegant--sub-title">
                Reasons for Report
                <i
                    class="fas fa-info-circle"
                    id="reasons-for-report"
                ></i>
                <b-popover target="reasons-for-report" triggers="hover" placement="top">
                    <template #title>Reasons for Report</template>
                    <div v-html="tooltip.reasons_for_report"></div>
                </b-popover>
            </h5>
            <reasons-for-report
                v-if='data.reasonsForReport != null'
                :data="data.reasonsForReport"
            ></reasons-for-report>
            <div v-else class="text-center mt-5 mb-5">
                <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
        </div>
        <!-- Reasons for Report End -->

        <!-- Scan vs Report Start -->
        <div class="innerBox mt-4">
            <h5 class="elegant--sub-title">
                Scan vs Report
                <i
                    class="fas fa-info-circle"
                    id="scan-vs-report"
                ></i>
                <b-popover target="scan-vs-report" triggers="hover" placement="top">
                    <template #title>Scan Vs Report</template>
                    <div v-html="tooltip.scan_vs_report"></div>
                </b-popover>
            </h5>
            <scan-vs-report
                v-if='data.scanVsReport != null'
                :data="data.scanVsReport"
                :filter="filter"
            ></scan-vs-report>
            <div v-else class="text-center mt-5 mb-5">
                <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
        </div>
        <!-- Scan vs Report End -->

    </div>
</template>

<script>
    import qs from 'qs'

    import highlightFilter from '@/components/filter/highlightFilter'
    import highlightStatsCustomer from './children/HighlightStatsCustomer'

    import reasonsForReport from './children/reasonsForReportBarChart'
    import scanVsReport from './children/scanVsReportBarChart'

    export default {
        metaInfo : {
            title : 'Highlight - Customer'
        },
        data () {
            return {
                tooltip : this.$store.state.tooltip.highlight.customer,
                filter : {

                },
                data : {
                    stats : {
                        "scan": null,
                        "report": null,
                        "valid": null,
                        "invalid": null,
                        "expired": null
                    },
                    reasonsForReport : null,
                }
            }
        },
        components : {
            highlightFilter,
            highlightStatsCustomer,

            reasonsForReport,
            scanVsReport,
        },
        mounted () {
            this.fetchData();
        },
        // watch : {
        //     'filter' : {
        //         deep : true,
        //         handler : 'fetchData'
        //     }
        // },
        methods : {
            onFilterChange (a) {
                for (var i in a) this.filter[i] = a[i];
                setTimeout(()=>{
                    this.fetchData();
                }, 100);
            },
            fetchData () {
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;
                
                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Stats
                this.$http.get(`/api/highlight/customer-variant-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    let data = resp.data.data;
                    for (var i in data) data[i] = data[i]?data[i]:0
                    this.data.stats = data;
                })
                .catch((err)=>{console.log(err)});

                //Reasons for Report
                this.$http.get(`/api/highlight/report-reason-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.reasonsForReport = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Scan Vs Report
                this.$http.get(`/api/highlight/scan-report-overview?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.scanVsReport = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }
</style>